export default function NavLink({ navLinkId, scrollToId, activeNavLinkId, setActiveNavLinkId }) {
	const handleClick = () => {
		setActiveNavLinkId(navLinkId);
		document.getElementById(scrollToId).scrollIntoView({
			behavior: 'smooth', // gives an ease-in-out effect to our scroll
		});
	};
	
	return (
		<div 
		 	id={navLinkId} 
			className={activeNavLinkId === navLinkId ? 'activeClass' : ''} 
		 	onClick={handleClick}
		>	
			{navLinkId}
		</div>
	);
};